module.exports = {"switchLan":"English"}


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/zh-CN.json
// module id = Rxfe
// module chunks = 1